import React, { useEffect, useState } from "react";
import EditorDashboardWrapper from "../../../layout/wrapper/EditorDashboardWrapper";
import styles from "../../../styles/pages/user/memberpartner/partner-message-video.module.scss";
import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import BackArrow from "../../../ui/Icons/BackArrow";
import message_blog_image from "../../../public/assets/images/messagedetails_inner.jpg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { style } from "@mui/system";
import UploadIcon from "../../../ui/Icons/Upload";
import PerfectScrollbar from "react-perfect-scrollbar";
import people from "../../../public/assets/images/people.svg";
import UploadPin from "../../../ui/Icons/UploadPin";
import DownArrowBlue from "../../../ui/Icons/DownArrowBlue";
import { useRef } from "react";
import MemberPartnerDashboard from "./MemberPartnerDashboard";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import TrashIcon from "../../../public/assets/icons/TrashIcon";
import AddPlusIcon from "../../../public/assets/icons/AddPlusIcon";
import BtnCrossIcon from "../../../public/assets/icons/BtnCrossIcon";
import useFetch from "../../../hooks/api/useFetch";
import {
  getAbsoluteDownloadURI,
  getAbsoluteImageURI,
  getStyledDateTime,
} from "../../../lib/functions/utils.lib";
import assest from "../../../json/assest";
import axiosInstance from "../../../api/axiosInstance";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Schema } from "@mui/icons-material";
import { getCookie } from "../../../lib/functions/storage.lib";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import * as yup from "yup";

const schema = yup.object().shape({
  message: yup.string().required("Message is required"),
  inquiry_id: yup.number().required(),
});
function PartnerMessageVideo() {
  const { id } = useParams();
  const { data, isError, isLoading, isSuccess, refetch } = useFetch(
    "message-detail",
    `inquiry/${id}`
  );

  const [sendButton, sendUpdateButton] = React.useState(false);

  const submitSendHandler = () => {
    sendUpdateButton(!sendButton);
  };

  const fileInput = useRef(null);

  const handleClick = () => {
    fileInput.current.children[0].children[0].click();
  };

  const updateInquiry = async (params) => {
    const { data: res } = await axiosInstance.post("update-inquery", {
      ...params,
      inquery_id: data?.data?.data?.id,
    });
    refetch();
    return res;
  };
  const userCookie = getCookie("userdetails");
  const user = JSON.parse(userCookie ? userCookie : "{}");

  const resolveInquiry = () => {
    updateInquiry({
      status: 1,
    });
  };
  const adminJoin = () => {
    updateInquiry({
      admin_joined: 1,
    });
  };
  const openInquiry = () => {
    updateInquiry({
      status: 0,
    });
  };
  const archiveInquiry = () => {
    updateInquiry({
      archive: 1,
    });
  };
  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.initiated?.name === inquiry?.last_message?.sender?.name)
        return {
          name: "Need your reply",
          class: `${styles.status_valuesec}`,
        };
      return {
        name: "Pending",
        class: `${styles.status_valuesec} ${styles.pendingstat}`,
      };
    }
    return {
      name: "Resolved",
      class: `${styles.status_valuesec} ${styles.resolved}`,
    };
  };
  const [respondToInquiry, setRespondToInquiry] = useState(false);

  const toggleRepondToInquiry = () => {
    setRespondToInquiry((prev) => !prev);
  };

  const router = useNavigate();
  const goBackToMessages = () => {
    // router.replace("/message");
    router(
      data?.data?.data?.video
        ? "/member-partner-dashboard/message"
        : "/member-partner-dashboard/support"
    );
  };
  const [status, setStatus] = useState({ name: "", class: "" });
  useEffect(() => {
    if (data?.data?.data) setStatus(getStatus(data?.data?.data));
  }, [isSuccess, data]);

  const {
    data: messageList,
    isError: messageListIsError,
    isLoading: messageListIsLoading,
    isSuccess: messageListIsSuccess,
    refetch: messageListRefetch,
  } = useFetch(
    ["inquiry-meassages", id],
    `inquiry/${id}/messages
      `
  );
  const {
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    formState: { errors },
    formState,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      message: "",
      receiver: data?.data?.data?.initiated?.id || null,
      inquiry_id: id || 0,
    },
  });

  const [attachments, setAttachments] = useState([]); // Set the initial state as an empty array of `File` objects

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setAttachments((curr) => [...curr, file]); // Use spread syntax to create a new array with the new file added
    }
  };

  const removeFile = (file_index) => {
    setAttachments((curr) => curr.filter((_, index) => file_index !== index));
  };

  const SubmitForm = async (messageData) => {
    try {
      const formData = new FormData();
      formData.append("type", "message");
      formData.append("receiver", data?.data?.data?.initiated?.id || null);
      formData.append("message", messageData.message);

      // Append each attachment to the FormData
      attachments.forEach((file, index) => {
        formData.append(`attachments[${index}]`, file);
      });

      const { data: res } = await axiosInstance.post(
        `inquiry/${id}/create-message`,
        formData
      );
      reset();
      setAttachments([]);
      messageListRefetch();
      console.log(res);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <MemberPartnerDashboardWrapper>
        <ApiLoader
          loading={isLoading && messageListIsLoading && !data?.data?.data}
        />
        <Box className={styles.messagedetails}>
          <Box className={styles.messagedetails_top}>
            <Typography variant="h4" className={styles.cmn_h4}>
              {data?.data?.data?.video ? "Message Details" : "Ticket Details"}
            </Typography>
            <Button className={styles.back_btn_sec} onClick={goBackToMessages}>
              <i>
                <BackArrow />
              </i>{" "}
              Back
            </Button>
          </Box>

          <Box className={styles.messagedetails_btms}>
            <PerfectScrollbar className={styles.scrolls_container}>
              <Box className={styles.message_details_outers}>
                <Box className={styles.message_details_outers_lf}>
                  {data?.data?.data?.video ? (
                    <Box className={styles.jumped_umbrella_outer}>
                      <Box className={styles.figure_main}>
                        <img
                          src={getAbsoluteImageURI(
                            data?.data?.data?.video?.thumbnail
                          )}
                          alt="image"
                        />
                      </Box>
                      <Box className={styles.jumped_umbrella_btms}>
                        <Box className={styles.more_details_top}>
                          <Typography variant="h5" className={styles.cmn_h5}>
                            <Link to="">
                              {data?.data?.data?.video?.title
                                ? data?.data?.data?.video?.title
                                : "N/A"}
                            </Link>
                          </Typography>
                          <Box className={styles.vsid_detais}>
                            <Box className={styles.vsid_detais_lft}>
                              <Button className={styles.vsid_span}>
                                VSID:{" "}
                                <Typography variant="caption">
                                  #{" "}
                                  {data?.data?.data?.video?.id
                                    ? data?.data?.data?.video?.id
                                    : "N/A"}
                                </Typography>
                              </Button>
                            </Box>
                            <Box className={styles.vsid_detais_rtt}>
                              <Button className={styles.more_details_btn}>
                                More details
                              </Button>
                            </Box>
                          </Box>
                        </Box>

                        <Box className={styles.more_details_btms}>
                          <Typography
                            variant="h5"
                            className={styles.creation_date}
                          >
                            Created on:
                          </Typography>
                          <Typography
                            variant="caption"
                            className={styles.creation_time}
                          >
                            {data?.data?.data?.created
                              ? getStyledDateTime(data?.data?.data?.created)
                              : "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box className={styles.ticket_details_outers}>
                      <List>
                        <ListItem>
                          <Box className={styles.subjectmatter_inner}>
                            <Typography
                              variant="h5"
                              className={styles.headinglicmn}
                            >
                              Subject:
                            </Typography>
                            <Typography variant="body1">
                              {data?.data?.data?.subject
                                ? data?.data?.data?.subject
                                : "-"}
                            </Typography>
                          </Box>
                        </ListItem>
                        <ListItem>
                          <Box className={styles.subjectmatter_inner}>
                            <Typography
                              variant="h5"
                              className={styles.headinglicmn}
                            >
                              Created on:
                            </Typography>
                            <Typography variant="body1">
                              {data?.data?.data?.created
                                ? getStyledDateTime(data?.data?.data?.created)
                                : "-"}
                            </Typography>
                          </Box>
                        </ListItem>
                        <ListItem>
                          <Box className={styles.subjectmatter_inner}>
                            <Typography
                              variant="h5"
                              className={styles.headinglicmn}
                            >
                              Last updated:
                            </Typography>
                            <Typography variant="body1">
                              {data?.data?.data?.last_message?.created
                                ? getStyledDateTime(
                                    data?.data?.data?.last_message?.created
                                  )
                                : "-"}
                            </Typography>
                          </Box>
                        </ListItem>
                        <ListItem>
                          <Box className={styles.subjectmatter_inner}>
                            <Typography
                              variant="h5"
                              className={styles.headinglicmn}
                            >
                              Sender:
                            </Typography>
                            <Typography variant="body1">
                              {data?.data?.data?.initiated?.role?.id === 1
                                ? `${data?.data?.data?.initiated?.name} ${data?.data?.data?.initiated?.last_name}`
                                : "Me, Myself & I"}
                              <Typography
                                variant="caption"
                                className={styles.cpy_items_span}
                              >
                                (
                                {
                                  data?.data?.data?.initiated?.role
                                    ?.display_name
                                }
                                )
                              </Typography>
                            </Typography>
                          </Box>
                        </ListItem>
                        <ListItem>
                          <Box className={styles.priority_listing_li}>
                            <Typography
                              variant="h5"
                              className={styles.headinglicmn}
                            >
                              Priority:
                            </Typography>
                            <Typography
                              variant="caption"
                              className={styles.low_styl_heading}
                            >
                              {data?.data?.data?.priority === 1
                                ? "Low"
                                : data?.data?.data?.priority === 3
                                ? "High"
                                : data?.data?.data?.priority === 4
                                ? "Critical"
                                : "Medium"}
                            </Typography>
                          </Box>
                        </ListItem>
                      </List>
                    </Box>
                  )}

                  <Box className={styles.file_uld_options_outr}>
                    <Box className={styles.file_uld_options_inner}>
                      <h5 className={styles.option_h5}>Attached Files</h5>
                      <Box className={styles.file_uploader_all}>
                        {data?.data?.data?.attachments?.length ? (
                          <PerfectScrollbar
                            className={styles.perfectscrollinfo}
                          >
                            {data?.data?.data?.attachments.map(
                              (attachment, index) => (
                                <Button
                                  className={
                                    attachment?.status
                                      ? `${styles.file_uploader_all_inner} ${styles.active}`
                                      : `${styles.file_uploader_all_inner}`
                                  }
                                  onClick={() =>
                                    window.open(
                                      getAbsoluteDownloadURI(attachment?.file),
                                      "_blank"
                                    )
                                  }
                                >
                                  <i>
                                    <UploadIcon />
                                  </i>
                                  <Box className={styles.rt_contents}>
                                    {attachment?.name}
                                  </Box>
                                </Button>
                              )
                            )}
                          </PerfectScrollbar>
                        ) : (
                          <Paper
                            className={`${styles.styledPaper} ${styles.noAttachFile}`}
                          >
                            <img
                              src={assest.IconNofile}
                              width={44}
                              height={44}
                              alt="icon"
                            />
                            <Typography variant="caption">
                              All files that will be uploaded will be displayed
                              in this section
                            </Typography>
                          </Paper>
                        )}
                      </Box>
                    </Box>

                    <Box className={styles.file_uld_options_inner}>
                      <Box className={styles.initiate_msg_div}>
                        {data?.data?.data?.initiated ? (
                          <Typography variant="body1">
                            <strong>
                              {" "}
                              {data?.data?.data?.initiated?.name
                                ? data?.data?.data?.initiated?.name
                                : "N/A"}
                            </strong>{" "}
                            <Typography
                              variant="caption"
                              className={styles.editor_spn}
                            >
                              ({" "}
                              {data?.data?.data?.initiated?.role?.display_name
                                ? data?.data?.data?.initiated?.role
                                    ?.display_name
                                : "N/A"}
                              )
                            </Typography>{" "}
                            initiated this message.
                          </Typography>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>

                    <Box className={styles.file_uld_options_inner}>
                      <Box className={styles.status_message_field}>
                        <Box className={styles.status_message_field_top}>
                          <Typography
                            variant="caption"
                            className={styles.status_text}
                          >
                            Status:
                          </Typography>
                          {data?.data?.data?.resolved_by ? (
                            <Typography
                              variant="caption"
                              className={styles.status_text}
                            >
                              <span>By:</span>
                              {data?.data?.data?.resolved_by?.name ||
                              data?.data?.data?.resolved_by?.last_name
                                ? `${data?.data?.data?.resolved_by?.name} ${data?.data?.data?.resolved_by?.last_name}`
                                : "N/A"}
                              <br />
                              <span>On:</span>
                              {data?.data?.data?.resolved_at
                                ? getStyledDateTime(
                                    data?.data?.data?.resolved_at
                                  )
                                : "N/A"}
                            </Typography>
                          ) : (
                            ""
                          )}
                          <Typography
                            variant="caption"
                            className={`${styles.status_valuesec} ${styles.pendingstat}`}
                          >
                            {status.name}
                          </Typography>
                        </Box>

                        <Box className={styles.status_message_field_btm}>
                          {status?.name === "Need your reply" ||
                          status?.name === "Pending" ? (
                            <List>
                              <ListItem>
                                <Button
                                  className={styles.black_btns}
                                  onClick={toggleRepondToInquiry}
                                >
                                  Respond
                                </Button>
                              </ListItem>

                              <ListItem>
                                <Button
                                  className={styles.gryy_btns}
                                  onClick={resolveInquiry}
                                >
                                  Mark as resolved
                                </Button>
                              </ListItem>
                            </List>
                          ) : status?.name === "Resolved" ? (
                            <List>
                              <ListItem>
                                <Button
                                  className={styles.black_btns}
                                  onClick={openInquiry}
                                >
                                  Open Again
                                </Button>
                              </ListItem>

                              <ListItem>
                                <Button
                                  className={styles.gryy_btns}
                                  onClick={archiveInquiry}
                                >
                                  Archive
                                </Button>
                              </ListItem>
                            </List>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box className={styles.message_details_outers_rt}>
                  <Box className={styles.message_fileout_div}>
                    {!respondToInquiry ? (
                      <Box className={styles.respond_div_marks}>
                        <Box className={styles.respond_div_marks_outer}>
                          <List>
                            <ListItem>
                              <Button
                                onClick={toggleRepondToInquiry}
                                className={styles.respond_btnss}
                              >
                                Respond
                              </Button>
                            </ListItem>
                            <ListItem>
                              <Button
                                onClick={resolveInquiry}
                                className={styles.respond_unread_btn}
                              >
                                Mark as resolved
                              </Button>
                            </ListItem>
                          </List>
                        </Box>
                      </Box>
                    ) : (
                      <Box className={styles.file_attached_textar}>
                        <Box className={styles.file_attached_textar_top}>
                          <Box className={styles.dated_file_attached}>
                            <Box className={styles.dated_file_attached_lft}>
                              <Box className={styles.editor_profile_parent}>
                                <Box
                                  className={styles.editor_profile_parent_lft}
                                >
                                  <img src={people} alt="" />
                                </Box>
                                <Box
                                  className={styles.editor_profile_parent_rtt}
                                >
                                  <Typography
                                    variant="h5"
                                    className={styles.cmn_h5}
                                  >
                                    {`${user.name} ${user.last_name}`}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    className={styles.dsgntns}
                                  >
                                    ({" "}
                                    {user?.role?.display_name
                                      ? user.role.display_name
                                      : "-"}
                                    )
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>

                            <Box className={styles.dated_file_attached_rtt}>
                              <Typography
                                variant="caption"
                                className={styles.date_spn_main}
                              >
                                {getStyledDateTime()}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>

                        <Box className={styles.file_attached_textar_mdl}>
                          <form>
                            <Box className={styles.input_box_textarea}>
                              <TextField
                                multiline
                                rows={4}
                                {...register("message")}
                              />
                            </Box>
                            <Box className={styles.formInner}>
                              <Box className={styles.attach_frm_messages}>
                                <Box
                                  className={styles.input_boxfile_attach}
                                  onClick={handleClick}
                                  ref={fileInput}
                                >
                                  <Box className={styles.input_boxfile_outer}>
                                    <Typography variant="caption">
                                      <i>
                                        <UploadPin />
                                      </i>{" "}
                                      Attach a file
                                    </Typography>
                                  </Box>
                                  <TextField
                                    type="file"
                                    id="upload"
                                    onChange={handleFileChange}
                                    hidden
                                    className={styles.file_uploaders}
                                  />
                                </Box>
                              </Box>
                              {/* <Box className={styles.attach_frm_messages}>
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  className={styles.showAddFile}
                                >
                                  <Button>
                                    <TrashIcon />
                                  </Button>
                                  <span>screenshot.png</span>
                                </Stack>
                              </Box>
                              <Box className={styles.attach_frm_messages}>
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  className={styles.showAddFile}
                                >
                                  <Button>
                                    <TrashIcon />
                                  </Button>
                                  <span>
                                    325007798_724967765618154_1330143271608700845_n.png
                                  </span>
                                </Stack>
                                <Button className={styles.btnAddBlack}>
                                  <AddPlusIcon />
                                </Button>
                              </Box>
                              <Box className={styles.attach_frm_messages}>
                                <Box className={styles.input_boxfile_attach}>
                                  <Box
                                    className={`${styles.input_boxfile_outer} ${styles.input_selectFile}`}
                                  >
                                    <Typography variant="caption">
                                      <i>
                                        <UploadPin />
                                      </i>{" "}
                                      Select file
                                    </Typography>
                                  </Box>
                                  <TextField
                                    type="file"
                                    className={styles.file_uploaders}
                                  />
                                </Box>
                                <Button
                                  className={`${styles.btnAddBlack} ${styles.roundBtn}`}
                                >
                                  <BtnCrossIcon />
                                </Button>
                              </Box> */}
                              <Box>
                                <List>
                                  {attachments?.length
                                    ? attachments.map((item, index) => {
                                        return (
                                          <ListItem key={index}>
                                            <span
                                              className={styles.btnStyledFile}
                                            >
                                              <img
                                                src={assest.IconTrash}
                                                width={16}
                                                height={16}
                                                alt="icon"
                                              />
                                              <Typography variant="overline">
                                                {item?.name ? item.name : "N/A"}
                                              </Typography>
                                            </span>
                                            <Button
                                              className={styles.btnClose}
                                              onClick={() => removeFile(index)}
                                            >
                                              <img
                                                src={assest.IconcrossRound}
                                                width={20}
                                                height={20}
                                                alt="icon"
                                              />
                                            </Button>
                                          </ListItem>
                                        );
                                      })
                                    : ""}
                                  {attachments?.length ? (
                                    <ListItem>
                                      <Box className={styles.addFiles}>
                                        <input
                                          type="file"
                                          id="upload"
                                          onChange={handleFileChange}
                                          hidden
                                        />
                                        <label htmlFor="upload">
                                          <img
                                            src={assest.IconAddfile}
                                            width={23.29}
                                            height={23.29}
                                            alt=""
                                          />
                                        </label>
                                      </Box>
                                    </ListItem>
                                  ) : (
                                    ""
                                  )}
                                </List>
                              </Box>
                            </Box>
                            <Box className={styles.btm_option_submitted}>
                              <Button className={styles.cancel_btns_pt}>
                                Cancel
                              </Button>
                              <Button
                                className={styles.submitted_btn_ps}
                                onClick={handleSubmit(SubmitForm)}
                              >
                                Send{" "}
                                <Typography variant="caption"> now</Typography>
                              </Button>
                            </Box>
                          </form>
                        </Box>
                      </Box>
                    )}

                    <Box className={styles.agent_share_fileattchd}>
                      <Box className={styles.agent_share_fileattchd_outer}>
                        {messageList?.data?.data.map((item, index) => (
                          <Box
                            className={styles.agent_share_inners}
                            key={index}
                          >
                            <Box className={styles.agent_share_inners_top}>
                              <Box className={styles.share_agents_lft}>
                                <Box className={styles.agent_info_fgr_Wrap}>
                                  <Box
                                    className={styles.agent_info_fgr_Wrap_img}
                                  >
                                    <img
                                      src={getAbsoluteImageURI(
                                        item?.sender?.image
                                      )}
                                      alt=""
                                    />
                                  </Box>

                                  <Box
                                    className={
                                      styles.agent_info_fgr_Wrap_content
                                    }
                                  >
                                    <Typography
                                      variant="h5"
                                      className={styles.cmn_h5}
                                    >
                                      {item?.sender?.name
                                        ? item?.sender?.name
                                        : "-"}
                                    </Typography>
                                    {item?.desgnation && (
                                      <Typography
                                        variant="caption"
                                        className={styles.desg_inner}
                                      >
                                        ({" "}
                                        {item?.sender?.role?.display_name
                                          ? item?.sender?.role?.display_name
                                          : "-"}
                                        )
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              </Box>

                              <Box className={styles.share_agents_rtt}>
                                <Typography
                                  variant="caption"
                                  className={styles.agent_date}
                                >
                                  {getStyledDateTime(item?.created)}{" "}
                                </Typography>
                              </Box>
                            </Box>

                            <Box className={styles.agent_share_inners_btm}>
                              <Box className={styles.description_box}>
                                <Typography variant="body1">
                                  {item?.message}
                                </Typography>
                              </Box>
                              {item?.attachments?.length ? (
                                <Box
                                  className={styles.description_attached_boxes}
                                >
                                  <Typography
                                    variant="h5"
                                    className={styles.cmn_h5}
                                  >
                                    Attached files:
                                  </Typography>
                                  {item?.attachments?.map(
                                    (attachment, index) => {
                                      return (
                                        <Button
                                          key={index}
                                          className={styles.button_pdf_styled}
                                          onClick={() =>
                                            window.open(
                                              getAbsoluteDownloadURI(
                                                attachment?.file
                                              ),
                                              "_blank"
                                            )
                                          }
                                        >
                                          <i>
                                            <DownArrowBlue />
                                          </i>
                                          {attachment?.name}
                                        </Button>
                                      );
                                    }
                                  )}
                                </Box>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </PerfectScrollbar>
          </Box>
        </Box>
      </MemberPartnerDashboardWrapper>
    </>
  );
}

export default PartnerMessageVideo;
